import React from 'react';
import ModalMessage from '../../UI/organisms/ModalMessage';
import Login from '../../Auth/Login';
import { withTranslation } from 'next-i18next';
import { Card, CardHeader, CardTitle, CardContent } from '@lb-classroom/ui';
import { X } from 'lucide-react';

interface LoginModalContentProps {
  t: (key: string, options?: Record<string, unknown>) => string;
  message?: string;
  messageType?: string;
  hideModal: () => void;
  clearModalMessage: () => void;
}

const LoginModalContent = (props: LoginModalContentProps) => {
  const { t, message, messageType, hideModal, clearModalMessage } = props;
  return (
    <div className="max-w-sm mx-auto">
      <Card className="z-50">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle>{t('modals.login.login')}</CardTitle>
          <button
            type="button"
            className="float-right cursor-pointer text-[1.4em] leading-none text-gray-500/70 hover:text-gray-700"
            onClick={hideModal}
          >
            <span className="sr-only">Close</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </CardHeader>
        <CardContent>
          <ModalMessage message={message} messageType={messageType} />
          <Login inModal={true} clearModalMessage={clearModalMessage} />
        </CardContent>
      </Card>
    </div>
  );
};

export default withTranslation('common')(LoginModalContent);
